import { Editor, Node, Path, Range, Transforms } from 'slate';
import { NESTED_LIST_PATH_INDEX, TEXT_PATH_INDEX } from "../constants.js";
import { getCursorPositionInNode, getListItemsInRange } from "../lib/index.js";

/**
 * Collapses the current selection (by removing everything in it) and if the cursor
 * ends up in a "list-item" node, it will break that "list-item" into 2 nodes, splitting
 * the text at the cursor location.
 */
export function splitListItem(editor) {
  if (!editor.selection) {
    return;
  }

  if (Range.isExpanded(editor.selection)) {
    // Remove everything in selection (this will collapse the selection).
    Transforms.delete(editor);
  }

  var listItemsInSelection = getListItemsInRange(editor, editor.selection);

  if (listItemsInSelection.length !== 1) {
    // Selection is collapsed, so there should be either 0 or 1 "list-item" in selection.
    // When no "list-items" are selected - there's no "list-item" to split.
    return;
  } // Selection is collapsed, `editor.selection.anchor` is equal to `editor.selection.focus`.


  var cursorPoint = editor.selection.anchor;
  var [[listItemNode, listItemPath]] = listItemsInSelection;
  var listItemTextPath = [...listItemPath, TEXT_PATH_INDEX];
  var {
    isEnd,
    isStart
  } = getCursorPositionInNode(editor, cursorPoint, listItemTextPath);

  if (isStart) {
    var newListItem = editor.createListItemNode({
      children: [editor.createListItemTextNode()]
    });
    Transforms.insertNodes(editor, newListItem, {
      at: listItemPath
    });
    return;
  }

  var newListItemPath = Path.next(listItemPath);
  var newListItemTextPath = Path.next(listItemTextPath);
  var hasNestedList = Node.has(listItemNode, [NESTED_LIST_PATH_INDEX]); // listItemNode.children.length > 1

  Editor.withoutNormalizing(editor, () => {
    if (isEnd) {
      var _newListItem = editor.createListItemNode({
        children: [editor.createListItemTextNode()]
      });

      Transforms.insertNodes(editor, _newListItem, {
        at: newListItemPath
      }); // Move the cursor to the new "list-item".

      Transforms.select(editor, newListItemPath);
    } else {
      // Split current "list-item-text" element into 2.
      Transforms.splitNodes(editor); // The current "list-item-text" has a parent "list-item", the new one needs its own.

      Transforms.wrapNodes(editor, editor.createListItemNode(), {
        at: newListItemTextPath
      }); // Move the new "list-item" up to be a sibling of the original "list-item".

      Transforms.moveNodes(editor, {
        at: newListItemTextPath,
        to: newListItemPath
      });
    } // If there was a "list" in the "list-item" move it to the new "list-item".


    if (hasNestedList) {
      Transforms.moveNodes(editor, {
        at: Path.next(listItemTextPath),
        to: [...newListItemPath, NESTED_LIST_PATH_INDEX]
      });
    }
  });
}